import img_loading from "@/../public/img/smile/gallery/img_loading.png";
import { cn } from "@/lib/utils";
import Image from "next/image";
import { useEffect, useRef, useState } from "react";

interface LazyImageProps {
  src: string;
  className?: string;
}

const LazyImage = ({
  src,
  className = "",
  ...options
}: LazyImageProps & any) => {
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  const [inView, setInView] = useState(false);
  const [inError, setInError] = useState(false);
  const handleImageLoaded = () => {
    setTimeout(() => {
      setIsImageLoaded(true);
    }, 1000);
  };

  // Simple gray placeholder (base64-encoded 1x1 pixel)
  const placeholderImage = img_loading.src;
  const imgRef = useRef<HTMLImageElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );

    if (imgRef.current) {
      observer.observe(imgRef.current);
    }

    return () => {
      if (imgRef.current) {
        observer.unobserve(imgRef.current);
      }
    };
  });

  return (
    <img
      ref={imgRef}
      src={isImageLoaded && inView && !inError ? src.trim() : placeholderImage}
      className={cn(
        className,
        isImageLoaded && 'fade-in-up',
        !isImageLoaded &&
          "animate-pulse object-cover object-center w-full h-full"
      )}
      onLoad={handleImageLoaded}
      onError={(e) => {
        setInError(true);
      }}
      {...options}
    />
  );
};

const LazyNextImage = ({
  src,
  className = "",
  ...options
}: LazyImageProps & any) => {
  const [inView, setInView] = useState(false);

  // Simple gray placeholder (base64-encoded 1x1 pixel)
  const placeholderImage = img_loading.src;
  const imgRef = useRef<HTMLImageElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );

    if (imgRef.current) {
      observer.observe(imgRef.current);
    }
    return () => {
      if (imgRef.current) {
        observer.unobserve(imgRef.current);
      }
    };
  });

  return (
    <Image
      ref={imgRef}
      src={inView ? src.trim() : placeholderImage}
      className={cn(
        className,
        !inView && "animate-pulse object-cover object-center w-full h-full"
      )}
      {...options}
    />
  );
};

const Lazybg = ({ src, className }: LazyImageProps & any) => {
  const [inView, setInView] = useState(false);

  // Simple gray placeholder (base64-encoded 1x1 pixel)
  const placeholderImage = img_loading.src;
  const imgRef = useRef<HTMLImageElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );

    if (imgRef.current) {
      observer.observe(imgRef.current);
    }

    return () => {
      if (imgRef.current) {
        observer.unobserve(imgRef.current);
      }
    };
  });

  return (
    <div
      className={cn(
        className || "w-full h-60 overflow-hidden bg-cover bg-center"
      )}
      ref={imgRef}
      style={{
        backgroundImage: `url("${
          inView ? src.trim() ?? placeholderImage : placeholderImage
        }")`,
      }}
    ></div>
  );
};

export { Lazybg, LazyImage, LazyNextImage };

